<!-- cv简历信息表-课程信息-组件级 -->
<template>
  <div class='detail-wrap-course'>
    <div class='detail-container'>
      <div class='cv-detail en'>
        <h4>Please specify the following information if the student is currently a senior in high school.</h4>
        <p class='warning pad-top'>(all information must agree with the official transcript)</p>
        <ul>
          <li>
            <span class='cv-detail-name'>Courses taken during the first semester of grade 12：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.seniorThree1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>Courses taken during the second semester of grade 12：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.seniorThree2)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>If has taken online courses, please list them here (Coursera, edX, etc..)：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.onlineCourses)'></span>
          </li>
        </ul>
        <h4 class='pad-top'>Please specify the following information if the student is currently studying in college</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>Classes taken in the first semester of freshman year and GPA received：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.freshman1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>Classes taken in the second semester of freshman year and GPA received：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.freshman2)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>Classes taken in the first semester as a sophomore and GPA received (if applicable)：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.sophomore1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>Classes taken in the second semester as a sophomore and GPA received (if applicable)：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.sophomore2)'></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
export default {
  name: '',
  components: {},
  data () {
    return {
      // 学员num
      menteeNum: '',
      // 课程信息详情
      courseDetailEn: {}
    }
  },
  computed: {},
  mounted () {
    this.menteeNum = this.$route.params.id
    this.getCourseDetailEn()
  },
  methods: {
    // 换行过滤
    lineFilter (value) {
      if (value) {
        let result = value
        for (let i = 0; i < result.length; i++) {
          result = result.replace(/\n/g, '<br/>').replace(/\r/g, '<br/>')
        }
        return result
      }
    },
    // 获取课程信息-en
    getCourseDetailEn () {
      cvService.cvCourseDetailEn({ num: this.menteeNum }).then(res => {
        if (res.data.model) {
          this.courseDetailEn = res.data.model
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
.detail-wrap-course {
  padding-top: 10px;
  .detail-container {
    background: #fff;
    padding: 10px;
    display: flex;
    .cv-detail {
      flex: 1;
      padding: 20px 0;
      li {
        font-size: 14px;
        color: #667483;
        letter-spacing: 0;
        line-height: 30px;
        padding: 10px 0 10px 60px;
        word-break: break-all;
        .cv-detail-name {
          display: block;
        }
        .cv-detail-val {
          display: block;
        }
      }
    }
    .cv-form {
      flex: 1;
      padding: 20px 0 20px 60px;
    }
    .cv-btn {
      flex: 0 0 160px;
      text-align: right;
      a {
        display: inline-block;
        width: 96px;
        height: 32px;
        background: rgb(224, 235, 254);
        border-radius: 8px;
        border-radius: 8px;
        font-size: 14px;
        color: #186ffa;
        letter-spacing: 0;
        text-align: center;
        line-height: 32px;
        margin-left: 10px;
      }
    }
  }
  h4 {
    font-size: 18px;
    color: #4aa6ff;
    letter-spacing: 0;
    padding-left: 60px;
  }
  .sub-btn {
    text-align: right;
    button {
      display: inline-block;
      width: 100px;
      height: 36px;
      background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
      border-radius: 8px;
      border-radius: 8px;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
    }
  }
  .warning {
    font-size: 14px;
    color: #ff6020;
    letter-spacing: 0;
    padding-left: 60px;
  }
  h4.no-pad,
  p.no-pad {
    padding-left: 0;
  }
  .pad-top {
    padding-top: 20px;
  }
  .pad-btm {
    padding-bottom: 20px;
  }
}
</style>
